var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RoleFilter',{on:{"filter":_vm.onFilter,"clear":_vm.onReset}})
}
var staticRenderFns = []

export { render, staticRenderFns }